import aerlox_h16 from "./icons/h16/aerlox.jpg";
import cool_h16 from "./icons/h16/cool.jpg";
import protector_h16 from "./icons/h16/protector.jpg";
import protector_plus_h16 from "./icons/h16/protector_plus.jpg";
import protector_plus_x_h16 from "./icons/h16/protector_plus_x.jpg";
import protector_x_h16 from "./icons/h16/protector_x.jpg";
import star_h16 from "./icons/h16/star.jpg";
import star_x_h16 from "./icons/h16/star_x.jpg";
import x_h16 from "./icons/h16/x.jpg";
import novo_x_h16 from "./icons/h16/novo_x.jpg";

import aerlox_h20 from "./icons/h20/aerlox.jpg";
import cool_h20 from "./icons/h20/cool.jpg";
import protector_h20 from "./icons/h20/protector.jpg";
import protector_plus_h20 from "./icons/h20/protector_plus.jpg";
import protector_plus_x_h20 from "./icons/h20/protector_plus_x.jpg";
import protector_x_h20 from "./icons/h20/protector_x.jpg";
import star_h20 from "./icons/h20/star.jpg";
import star_x_h20 from "./icons/h20/star_x.jpg";
import x_h20 from "./icons/h20/x.jpg";
import novo_x_h20 from "./icons/h20/novo_x.jpg";
import novo_h20 from "./icons/h20/novo.jpg";

import aerlox_h27 from "./icons/h27/z_aerlox.png";
import cool_h27 from "./icons/h27/z_cool.png";
import protector_h27 from "./icons/h27/z_protector.png";
import protector_plus_h27 from "./icons/h27/z_protector_plus.png";
import star_h27 from "./icons/h27/z_star.png";

import aerlox_h30 from "./icons/h30/aerlox.jpg";
import cool_h30 from "./icons/h30/cool.jpg";
import protector_h30 from "./icons/h30/protector.jpg";
import protector_plus_h30 from "./icons/h30/protector_plus.jpg";
import protector_plus_x_h30 from "./icons/h30/protector_plus_x.jpg";
import protector_x_h30 from "./icons/h30/protector_x.jpg";
import star_h30 from "./icons/h30/star.jpg";
import star_x_h30 from "./icons/h30/star_x.jpg";
import x_h30 from "./icons/h30/x.jpg";
import novo_x_h30 from "./icons/h30/novo_x.jpg";
import novo_h30 from "./icons/h30/novo.jpg";

import slurry_h20 from "./icons/original/slurry.jpg";
import slurry_h30 from "./icons/original/slurry.jpg";
import platinum_h20 from "./icons/original/platinum.jpg";
import platinum_h30 from "./icons/original/platinum.jpg";

const images = {
    aerlox_h16,
    cool_h16,
    protector_h16,
    protector_plus_h16,
    protector_plus_x_h16,
    protector_x_h16,
    star_h16,
    star_x_h16,
    x_h16,
    novo_x_h16,

    aerlox_h20,
    cool_h20,
    protector_h20,
    protector_plus_h20,
    protector_plus_x_h20,
    protector_x_h20,
    star_h20,
    star_x_h20,
    x_h20,
    novo_x_h20,

    aerlox_h27,
    cool_h27,
    protector_h27,
    protector_plus_h27,
    star_h27,

    aerlox_h30,
    cool_h30,
    protector_h30,
    protector_plus_h30,
    protector_plus_x_h30,
    protector_x_h30,
    star_h30,
    star_x_h30,
    x_h30,
    novo_x_h30,

    slurry_h20,
    slurry_h30,
    platinum_h20,
    platinum_h30,
    novo_h20,
    novo_h30,
}

export default images;